import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="discount-bundle-list"
export default class extends Controller {
  connect() {
    this.discountDatatableController.updatePageNumber(this.discountDatatableController.currentPageNumber)
  }

  get discountDatatableController() {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'discount-datatable';
    });
  }
}
